import { isBudgetCategoryRequired } from 'domain/shared/budget';
import { DefaultInputPropTypes, useFormContext } from 'framework/form';
import { BudgetCategoryDropdown } from 'domain/shared/budget';
import { get } from 'lodash';

const BudgetCategoryDropdownWrapper = ({
  dateValue,
  accountIdValue,
  ...props
}: DefaultInputPropTypes<string> & {
  dateValue: string;
  accountIdValue: string;
}) => {
  const { data } = useFormContext();
  const accountId = get(data, accountIdValue);

  return (
    <BudgetCategoryDropdown
      disabled={!isBudgetCategoryRequired(accountId)}
      source="budgetCategory"
      label="Budget Category"
      dateValue={dateValue}
      accountIdValue={accountId}
    />
  );
};

export default BudgetCategoryDropdownWrapper;
